<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    custom-class="purchase-dialog"
    width="600px"
    @close="handleClose"
  >
    <div class="dialog-content">
      <div class="dialog-logo">
        <img :src="require('@/assets/images/logo-active.png')" :alt="getText('purchaseDialog.logoAlt', '亚科Logo')">
      </div>
      <div class="dialog-title">
        {{ getText('purchaseDialog.title', '更多品牌产品，尽在星元素甄选') }}
      </div>
      <el-button type="primary" class="goto-store" @click="handleGotoStore">
        {{ getText('purchaseDialog.gotoStore', '前往商城查看') }}
      </el-button>
      <div class="store-info">
        <img :src="require('@/assets/images/yssc-logo.png')" alt="星元素甄选" class="store-logo">
        <span>{{ getText('purchaseDialog.storeInfo', '由亚科集团旗下星元素甄选提供服务') }}</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'PurchaseDialog',

  data() {
    return {
      visible: false
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh'
    })
  },

  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    }
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },

    // 打开弹窗
    show() {
      this.visible = true
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false
    },

    // 跳转到商城
    handleGotoStore() {
      window.open('https://www.b2star.com', '_blank')
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.purchase-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 24px 16px 16px 16px;
    background: #fff;
    border-radius: 12px;
  }
  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .dialog-logo {
      margin-bottom: 12px;
      img {
        width: 56px;
        height: 56px;
        border-radius: 12px;
      }
    }
    .dialog-title {
      font-size: 16px;
      color: #222;

      margin-bottom: 20px;
      text-align: center;
    }
    .goto-store {
      width: 100%;
      max-width: 260px;
      height: 44px;
      background: #46618F;
      border: none;
      border-radius: 22px;
      color: #fff;
      font-size: 16px;
      margin-bottom: 32px;

    }
    .store-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .store-logo {
        width: 60px;
        height: 18px;
      }
      span {
        font-size: 12px;
        color: #999;
      }
    }
  }
}
:deep(.el-dialog) {
  width: 90vw !important;
  max-width: 340px;
  min-width: 0;
  border-radius: 12px;
}
:deep(.el-dialog__headerbtn) {
  right: 10px;
  top: 10px;
  .el-dialog__close {
    color: #bbb;
    font-size: 18px;
  }
}
</style> 